export class EmailFooter {
    id: string;
    clientId?: string;
    label: string;
    htmlContent: string;
    isEnabled: boolean;
    deletedOn?: Date;
    inUse: boolean;
  
    constructor(options?: Partial<EmailFooter>) {
        if (options) {
        Object.assign(this, options);
        }
    }
}

export class WorkflowActivityEmailFooter {
    id: string;
    emailFooterId: string;
    workflowId: string;
    workflowName: string;
    activityId: string;
    activityName: string;
}